import React from 'react';
import {TooltipIcon} from '../../icons';
import {Tooltip} from 'react-tooltip';

import './index.scss';

function Input({
  onChange = () => {},
  label,
  value,
  has_tooltip = false,
  tooltipText,
  placeholder = 'Placeholder',
  id,
  type = 'text',
  is_form = false,
  disabled = false,
}) {
  return (
    <div className={`f-build__input ${is_form ? 'is_form' : ''}`}>
      <div className='f-build__input-block'>
        <label htmlFor={id}>{label}</label>
        {has_tooltip ? (
          <React.Fragment>
            <div
              className={'f-build__input-tooltip'}
              data-tooltip-id={`input-${id}`}
              data-tooltip-content={tooltipText}
            >
              <TooltipIcon />
            </div>
            <Tooltip id={`input-${id}`} place={'bottom'} />
          </React.Fragment>
        ) : null}
      </div>
      <input
        disabled={disabled}
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
}

export default Input;
